/* eslint-disable @trello/export-matches-filename */

export const HYGIENE_MESSAGE_ID = 'primary-email-hygiene';
export const CHANGE_EMAIL_MESSAGE_ID = 'peh-change-email';
